import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const IssueInvoice = ({
  size,
  type,
  theme,
  className,
  dataTestId = "issue-invoice-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path
      d="M.132 1.419C.132.682.728.085 1.464.085H7.44c.354 0 .693.14.943.39l3.61 3.61c.25.25.39.59.39.943v1.788a.667.667 0 0 1-1.333 0V5.648H9.038a2 2 0 0 1-2-2v-2.23H1.465v13.165h9.586v-.191a.667.667 0 1 1 1.333 0v.19c0 .737-.597 1.334-1.333 1.334H1.465A1.333 1.333 0 0 1 .13 14.582V1.42Zm8.24.93 1.965 1.966H9.038a.667.667 0 0 1-.667-.667v-1.3Zm4.29 9.92a.667.667 0 1 0 .949.938l2.364-2.393-2.364-2.392a.667.667 0 0 0-.949.937l.78.789h-2.87a.667.667 0 0 0 0 1.333h2.87l-.78.789ZM3.258 7.714H8.28a.667.667 0 0 1 0 1.333H3.258a.667.667 0 0 1 0-1.333ZM2.59 4.981c0 .368.299.667.667.667h1.23a.667.667 0 0 0 0-1.333h-1.23a.667.667 0 0 0-.667.666Zm.667 6.5a.667.667 0 0 1 0-1.333h1.23a.667.667 0 0 1 0 1.333h-1.23Z"
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </SVGIcon>
);
